import { Outlet, useParams } from 'react-router-dom'
import { Home, Mail, Settings, Users } from 'lucide-react'
import { SubNavigation } from '@/components/ui/SubNavigation'

export function OrderConfirmationLayout() {
  const { workflowId } = useParams<{ workflowId: string }>()
  const base = `/workflow/${workflowId}`

  return (
    <div className="flex flex-col min-h-full">
      <SubNavigation
        rootLabel="Order Confirmation"
        children={[
          { label: 'Overview', to: `${base}/overview`, icon: <Home /> },
          { label: 'Inbox', to: `${base}/inbox`, icon: <Mail /> },
          { label: 'Suppliers', to: `${base}/suppliers`, icon: <Users /> },
          { label: 'Settings', to: `${base}/settings`, icon: <Settings />, end: true },
        ]}
      />

      {/* Page content */}
      <div className="flex-1 px-6 py-6">
        <Outlet />
      </div>
    </div>
  )
}
